module.exports = __webpack_public_path__ + "img/ambientacion3.bd1deb83.jpg";